import angular from 'angular';
import { HistoricoTabelaComponent } from './historico-tabela/historico-tabela.component';

export const HistoricoPedidoModule = 'mandaeApp.historico.pedido';

angular.module(HistoricoPedidoModule, [])
  .component(HistoricoTabelaComponent.componentName, HistoricoTabelaComponent);
